import { render } from "./ArtworkCard.vue?vue&type=template&id=6e646c48&scoped=true&ts=true"
import script from "./ArtworkCard.vue?vue&type=script&lang=ts"
export * from "./ArtworkCard.vue?vue&type=script&lang=ts"

import "./ArtworkCard.vue?vue&type=style&index=0&id=6e646c48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e646c48"]])

export default __exports__